export const BCX_PHONE = "1-800-395-6360";
export const BCX_EMAIL = "info@basicareplus.com";
